/**
 * Help form
 *
 * WARNING: This JS may not be served by the same service as the one which serves
 * HTML/CSS which this JS depends on. E.g. this JS may be served by a BabyStorm
 * while the HTML/CSS may be served by Storm. Take care when updating this JS or any
 * related HTML/CSS.
 * See https://wiki.yext.to/index.php/Postmortem:IN-1085_Capacity_Limit_Exceeded_Modal_in_Customer_Portal#Root_causes
 * for context.
 *
 * @author MattJS (matt@yext.com)
 */
goog.module('yext.helpform');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const Field = goog.require('yext.Field');
const notify = goog.require('yext.notify');


var initialized = false;
var defaultEmail = '';

var $contact = $('.js-help-form-contact');
var $helpForm = $('.js-help-form');
var $email; var $subject; var $description;

/**
 * Set dialog back to default values
 */
var clearDialog = function() {
  $email.val(defaultEmail);
  $subject.val('');
  $description.val('');
  $helpForm.find('.js-error, .js-custom-error').hide();
};

/**
 * Provides lazy initialization
 * @suppress {deprecated}
 */
var lazyInitialize = function() {
  if (!initialized) {
    $email = $helpForm.find('.js-help-form-email'),
    $subject = $helpForm.find('.js-help-form-subject'),
    $description = $helpForm.find('.js-help-form-description');

    // Store default email value
    defaultEmail = $email.val();

    var field = new Field($helpForm);

    field.setValidator(function() {
      var valid = true;
      $helpForm.find('.js-error, .js-custom-error').hide();
      if (!$subject.val()) {
        $subject.closest('.js-help-form-field')
          .find('.js-error').show();
        valid = false;
      }
      if (!$description.val()) {
        $description.closest('.js-help-form-field')
          .find('.js-error').show();
        valid = false;
      }
      return valid;
    });

    $helpForm.on('beforeSubmit.field', function() {
      field.additionalData = [{
        name: 'sourceLink',
        value: window.location.href,
      }];
    });

    $helpForm.on('save.field', function(e, response) {
      $helpForm.find('.js-error, .js-custom-error').hide();
      if (!response.errors) {
        $helpForm.dialog('close');
        notify.showSuccess('Your request was sent along succesfully!');
      } else {
        for (var i = 0; i < response.errors.length; i++) {
          var $field;
          switch (response.errors[i].field) {
            case 'EMAIL':
              $field = $email.closest('.js-help-form-field');
              break;
            case 'SUBJECT':
              $field = $subject.closest('.js-help-form-field');
              break;
            case 'DESCRIPTION':
              $field = $description.closest('.js-help-form-field');
              break;
          }
          $field.find('.js-custom-error')
            .text(response.errors[i].message).show();
        }
      }
    });

    $helpForm.on('error.field', function() {
      notify.showError(yext.msg('Oops looks like something went wrong.'));
    });

    // Set up dialog
    $helpForm.dialog({
      modal: true,
      autoOpen: false,
      draggable: false,
      resizable: false,
      width: 685,
      title: yext.msg('Contact support'),
      close: clearDialog,
    });

    $helpForm.find('.js-close-help-form').click(function() {
      $helpForm.dialog('close');
    });
  }
  initialized = true;
};

/**
 * Initialize module
 *
 * Most of the initialization is made lazy since this is available on
 * every page but not used on every page load
 * @suppress {deprecated}
 */
function init() {
  // Bind menu
  $contact.click(function() {
    lazyInitialize();
    $helpForm.dialog('open');
    $('.js-help-form-dropdown').hide();
  });
}
goog.exportSymbol('yext.helpform.init', init);

exports = {
  init,
};
